import React, { useState } from 'react';

import { LockIcon } from '../../../../assets/misc';
import UpgradeModal from '../../../common/upgrade_modal/upgrade_modal.component';

const Lock = () => {
  const [show, setShow] = useState(false);

  return (
    <>
      <img
        src={LockIcon}
        alt="locked"
        className="lock-icon mr-0"
        onClick={() => setShow(true)}
      />
      <UpgradeModal isVisible={show} setIsVisible={(v) => setShow(v)} />
    </>
  );
};

export default Lock;
